<div>
	<ngx-skeleton-loader [theme]="{ width: '150px', height: '150px', margin: '10px 10px' }" appearance="circle"></ngx-skeleton-loader>
</div>
